import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Navigation from './components/Navigation'
import { BrowserRouter } from 'react-router-dom'
    

ReactDOM.render(<BrowserRouter><Navigation/></BrowserRouter>, document.getElementById('navigation'));   

ReactDOM.render(<BrowserRouter><App/></BrowserRouter>, document.getElementById('root'));